import React from "react";
import { useLocation } from "react-router-dom";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_M3_RabinKarp = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <DAAModuleSubtopic
      title="Rabin-Karp Algorithm - String Matching"
      videos={["https://www.youtube.com/embed/qQ8vS2btsxI", "https://www.youtube.com/embed/QTvz9_IsFrk"]}
      takeaways={[
        { text: "Why should we use Rabin-Karp over KMP algorithm." },
        { text: "Demonstration of rolling hashing function." },
        { text: "Finding spurious hits." },
        { text: "Time complexity and space complexity." },
      ]}
      questions={[
        "Only numerical questions from this topic.",
        "Asks how many spurious hits does the algorithm encounter in the Text, when looking for the pattern.",
        "Pseudocode for the Rabin-Karp algorithm (may ask in FAT combination with numerical).",
      ]}
      exampleVideos={[]}
      subtopics={subtopics}
      subjectPath={subjectPath}
    />
  );
};

export default DAA_M3_RabinKarp;
